<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Icon from '~/components/icon.vue';
import SvgLoader from 'components/svg_loader.vue';

export default {
  components: {
    Icon,
    SvgLoader
  },

  data() {
    return {
      code: this.$store.state.discountCode,
      enabled: false,
      invalid: false
    };
  },

  computed: {
    ...mapState({
      appliedDiscountCode: 'discountCode',
      validDiscountCode: 'validDiscountCode',
      discountCodeLabel: (state) => state.product.discountCodeLabel
    }),

    iconName() {
      return this.enabled ? 'chevron-up' : 'chevron-down';
    },

    inputStatusIconName() {
      if (this.invalid) return 'x';
      if (this.isInputChecked) return 'check';
      return '';
    },

    isInputChecked() {
      return this.validDiscountCode && this.code === this.appliedDiscountCode;
    },

    showInputField() {
      return this.enabled ? (this.invalid ? 'c-form__field--error' : '') : 'd-none';
    },

    toggleButton() {
      return this.code && this.code.length > 0;
    },

    discountCodeSvg() {
      return 'payment_page/discount_code';
    },

    discountCodeLabelName() {
      return this.discountCodeLabel || this.t('pay.js.marketing.summary.discount_code');
    }
  },

  watch: {
    code() {
      this.invalid = false;
    }
  },

  mounted() {
    if (this.appliedDiscountCode && !this.validDiscountCode) {
      this.invalid = true;
      this.enabled = true;
    }
  },

  methods: {
    ...mapActions([
      'updateAmounts'
    ]),

    ...mapMutations([
      'setDiscountCode'
    ]),

    toggleDiscount() {
      this.enabled = !this.enabled;
    },

    activate() {
      this.setDiscountCode({
        discountCode: this.code
      });

      this.updateAmounts().then((response) => {
        if (response.valid) {
          this.invalid = false;
          this.toggleDiscount();
        } else {
          this.invalid = true;
        }
      }).catch(() => {
        // TODO: Add real error handling
      });
    }
  }
};
</script>

<template>
  <div class="c-summary__row flex-column">
    <div
      class="c-discount-code"
      @click="toggleDiscount"
    >
      <svg-loader
        class="c-discount-code__icon"
        :path="discountCodeSvg"
      />

      <div>
        {{ discountCodeLabelName }}

        <small
          v-if="validDiscountCode"
        >
          <em>{{ appliedDiscountCode }}</em>
        </small>
      </div>

      <button
        type="button"
        class="c-discount-code__arrow"
      >
        <icon
          :name="iconName"
          size="small"
        />
      </button>
    </div>

    <div
      :class="showInputField"
      class="c-discount-code__input c-form__input mt-3"
    >
      <div class="c-input-group">
        <input
          id="discount-input"
          v-model.trim="code"
          type="text"
        >
        <input
          type="hidden"
          :value="appliedDiscountCode"
          name="discount_code"
        >
        <div
          v-if="toggleButton"
          class="c-input-group__append"
        >
          <button
            class="c-discount-code__button"
            @click.prevent="activate"
          >
            {{ t('pay.js.marketing.summary.activate_discount_code') }}
          </button>

          <div
            v-if="inputStatusIconName"
            class="c-form__input__status"
          >
            <icon
              :name="inputStatusIconName"
              size="small"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
